import React, { useRef } from 'react';
import { useSelector } from 'react-redux';
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogOverlay
} from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { selectAlertModalOpen, selectAlertModalOptions } from '../../../redux/modules/alertModal';

function AlertContainer({ children }) {
  const { title, onClose } = useSelector(selectAlertModalOptions);
  const isOpen = useSelector(selectAlertModalOpen);
  const cancelRef = useRef();

  return (
    <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
      <AlertDialogOverlay>
        <AlertDialogContent textAlign="center">
          <AlertDialogHeader textStyle="displayXxs600">{title}</AlertDialogHeader>
          {children}
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
}

AlertContainer.propTypes = {
  /** Body of the dialog */
  children: PropTypes.element
};

export default AlertContainer;
